"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function CarFooter(props) {
    var children = props.children;
    return (react_1.default.createElement("div", { className: "azgazui__footer" },
        react_1.default.createElement("div", { className: "container" }, children)));
}
exports.default = CarFooter;
CarFooter.displayName = 'CarFooter';
CarFooter.propTypes = {
    children: prop_types_1.default.node.isRequired,
};
